export const REPUTATION_PLATFORMS_OPTIONS = [
  { value: 'infatuation', label: 'Infatuation' },
  { value: 'eater', label: 'Eater' },
  { value: 'michelin', label: 'Michelin' },
]
